export default {
  esg_dashboard: {
    title: 'ダッシュボード',
  },
  improvement_plans: {
    title: '改善計画',
  },
  question_group_section: {
    card_title: '未回答の調査票/サーベイ',
    list_header_buyer_company_name: '評価依頼企業',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: '回答期限',
    list_header_status: 'ステータス',
    number_of_answered_label: '回答数',
    number_of_answered_unit: '問',
    number_of_answered: '進捗率： {answered}/{total}問',
    status_re_answer_request: '取り下げ依頼中',
    answer: '回答する',
    withdrawn: '差し戻し済み',
    no_survey_response_requests_text_1:
      '調査票/サーベイの回答依頼はありません。\n詳細なESG評価やESGの取り組み支援を希望する場合は',
    contact: 'お問い合わせ',
    no_survey_response_requests_text_2: 'ください。'
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: '評価依頼企業',
    list_header_question: '調査票',
    list_header_create_at: '発行日',
    list_header_deadline: '有効期限',
    list_header_status: 'ステータス',
    limit_one_year: '発行日から1年間',
    esg_score: 'ESGスコア',
    esg_rating: 'ESGレーティング',
    detail: '詳細',
  },
  faq_section: {
    card_title: 'よくある質問',
    faq_why_request: {
      question:
        '取引先からASUENE ESGの回答を依頼されたのですが、なぜこのような依頼が来たのでしょうか？',
      answer:
        '近年、大手企業を中心にサステナブル調達への取り組みが注目されており、サプライチェーンにおける環境や人権を含むESGに関連した社会的要請に配慮して事業を行うことが求められています。このような取り組みにおいて、大手企業は自社の取り組みだけではなく、「自社の取引先に対してもESGの取り組みを実施しているか」を把握する必要があります。',
    },
    faq_what_benefit: {
      question:
        'ASUENE ESGに回答することによって、どのような利点がありますか？',
      answer:
        'ASUENE ESGを受けることは、以下の3つの利点が存在します。\n1）ESGに関する貴社の評価点と改善点を把握することができる \n2）貴社のESG評価を同業他社と比較することができる \n3）ESG評価結果を外部に公開することで、ESGへの取り組み内容をアピールすることができる',
    },
    list: '一覧をみる',
  },
  contact_section: {
    card_title: 'お問い合わせ',
    description:
      '調査票/サーベイ内容や回答方法で不明点がある際はいつでもお問合せください。\nより具体的なESG取組み改善・伴走支援をご希望の方は別途専門コンサルタントの支援を受ける事も可能です。',
    inquiry: 'お問い合わせ',
  },
}
